import { useTranslation } from 'i18n';
import { Grid, Stack, Typography } from 'ui';

import { guideImages } from '../../data';
import { EvidenceFeedback } from '../EvidenceFeedback/EvidenceFeedback';

export const PartTwo = () => {
  const { t } = useTranslation('features');

  return (
    <Stack
      sx={{
        textAlign: 'start',
        gap: 4,
      }}
    >
      <Typography>{t('helpGuides.aiBale.partTwo.intro')}</Typography>
      <Grid container>
        <Grid size={6}>
          <EvidenceFeedback
            src={guideImages.goodBaleDistance}
            variant="yes"
            caption={t('helpGuides.aiBale.partTwo.captions.greatDistanceFromBale')}
          />
        </Grid>
        <Grid size={6}>
          <EvidenceFeedback
            src={guideImages.goodBaleFaceShown}
            variant="yes"
            caption={t('helpGuides.aiBale.partTwo.captions.nearlyAllBaleFaceShown')}
          />
        </Grid>
        <Grid size={6}>
          <EvidenceFeedback
            src={guideImages.goodBaleBackgroundOk}
            variant="yes"
            caption={t('helpGuides.aiBale.partTwo.captions.someBackgroundIsOk')}
          />
        </Grid>
        <Grid size={6}>
          <EvidenceFeedback
            src={guideImages.goodBaleQualityPhoto}
            variant="yes"
            caption={t('helpGuides.aiBale.partTwo.captions.goodQualityPhoto')}
          />
        </Grid>
        <Grid size={6}>
          <EvidenceFeedback
            src={guideImages.goodBaleBaleFocus}
            variant="yes"
            caption={t('helpGuides.aiBale.partTwo.captions.clearWhichBaleToFocusOn')}
          />
        </Grid>
        <Grid size={6}>
          <EvidenceFeedback
            src={guideImages.goodBaleNotTight}
            variant="yes"
            caption={t('helpGuides.aiBale.partTwo.captions.materialNotTooTightlyPacked')}
          />
        </Grid>
        <Grid size={6}>
          <EvidenceFeedback
            src={guideImages.goodBaleNotTight2}
            variant="yes"
            caption={t('helpGuides.aiBale.partTwo.captions.materialNotTooTightlyPacked')}
          />
        </Grid>
        <Grid size={6}>
          <EvidenceFeedback
            src={guideImages.goodBaleQualityDistance}
            variant="yes"
            caption={t('helpGuides.aiBale.partTwo.captions.goodQualityPhotoAndDistanceFromBale')}
          />
        </Grid>

        <Grid size={6}>
          <EvidenceFeedback
            src={guideImages.badBaleManySides}
            variant="no"
            caption={t('helpGuides.aiBale.partTwo.captions.tooManyBalesManySidesVisible')}
          />
        </Grid>
        <Grid size={6}>
          <EvidenceFeedback
            src={guideImages.badBaleNotStraight}
            variant="no"
            caption={t('helpGuides.aiBale.partTwo.captions.tooManyBalesAngleNotStraightPoorQuality')}
          />
        </Grid>
        <Grid size={6}>
          <EvidenceFeedback
            src={guideImages.badBaleManyFar}
            variant="no"
            caption={t('helpGuides.aiBale.partTwo.captions.tooManyBalesTooFarAway')}
          />
        </Grid>
        <Grid size={6}>
          <EvidenceFeedback
            src={guideImages.badBaleManyFar2}
            variant="no"
            caption={t('helpGuides.aiBale.partTwo.captions.tooManyBalesTooFarAway')}
          />
        </Grid>
        <Grid size={6}>
          <EvidenceFeedback
            src={guideImages.badBaleBlurry}
            variant="no"
            caption={t('helpGuides.aiBale.partTwo.captions.photoTooBlurry')}
          />
        </Grid>
        <Grid size={6}>
          <EvidenceFeedback
            src={guideImages.badBaleClose}
            variant="no"
            caption={t('helpGuides.aiBale.partTwo.captions.tooClose')}
          />
        </Grid>
        <Grid size={6}>
          <EvidenceFeedback
            src={guideImages.badBaleFlatPacked}
            variant="no"
            caption={t('helpGuides.aiBale.partTwo.captions.materialTooFlatAndTightlyPacked')}
          />
        </Grid>
        <Grid size={6}>
          <EvidenceFeedback
            src={guideImages.badBaleUnclearBale}
            variant="no"
            caption={t('helpGuides.aiBale.partTwo.captions.unclearWhichIsMainBale')}
          />
        </Grid>
      </Grid>
    </Stack>
  );
};
